// Update SHOPIFY_STORE to your live Shopify/reserve30.in store URL.
// Each product's `shopifyUrl` should point to its Shopify product page;
// `buyUrl` can point directly to a Shopify cart/checkout permalink.
export const SHOPIFY_STORE = "https://reserve30.in";

export const PRODUCTS = [
  {
    slug: "rouge-eclipse",
    families: ["Floral", "Oud", "Spicy"],
    name: "Rouge Éclipse",
    collection: "unisex",
    accord: "Dark Rose · Saffron · Oud",
    description: "A crimson veil of saffron-laced rose eclipsed by smoked oud. Magnetic after dusk.",
    image: "https://cdn.shopify.com/s/files/1/0735/8273/9521/files/rouge-eclipse-1-light_9224a576-5679-4d30-a5fd-2414e4c9797c.png",
    aestheticImage: "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/7b8936fc976c41d4934a1b30a669611a823c842ed5996ca60252ae5134553999.jpeg",
    notesImage: "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/a11639315416d0da0f8d19ee9ece557274d14b794e68e3c1ab48d9f7d29f0bde.jpeg",
    notes: { top: "Saffron · Dark Rose", heart: "Jasmine · Oud Smoke", base: "Amberwood · Musk" },
    price50: 1990,
    price10: 499,
    shopifyUrl: `${SHOPIFY_STORE}/products/rouge-eclipse`,
    buyUrl: `${SHOPIFY_STORE}/products/rouge-eclipse`,
  },
  {
    slug: "imperial-ash",
    families: ["Woody", "Smoky", "Fresh"],
    name: "Imperial Ash",
    collection: "for-him",
    accord: "Vetiver · Smoked Cedar · Iris",
    description: "Cold smoke over polished cedar. A study in restraint — grey, architectural, absolute.",
    image: "https://cdn.shopify.com/s/files/1/0735/8273/9521/files/imperial-ash-1-light_be8d19cb-6951-4348-80d3-7f8af8f69481.png",
    aestheticImage: "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/f782952d6209f09fecfc7d87f747cafddd6f2dedd49304cc69553df0a4ca0a4b.jpeg",
    notesImage: "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/a9b30879541a5468025bd241fcc773b0f73fae33fea8e5a9df726e8a37daafc4.jpeg",
    notes: { top: "Fresh Pineapple", heart: "Vetiver · Iris", base: "Smoked Cedar · Ash Woods" },
    price50: 1990,
    price10: 499,
    shopifyUrl: `${SHOPIFY_STORE}/products/imperial-ash`,
    buyUrl: `${SHOPIFY_STORE}/products/imperial-ash`,
  },
  {
    slug: "ember-rush",
    families: ["Ambery", "Sweet", "Tobacco"],
    name: "Ember Rush",
    collection: "unisex",
    accord: "Amber · Tobacco · Vanilla Bourbon",
    description: "Molten amber struck with bourbon vanilla. Warmth that arrives before you do.",
    image: "https://cdn.shopify.com/s/files/1/0735/8273/9521/files/ember-rush-1-light_62944a38-c133-4ad2-b037-f5cab7e3be6c.png",
    aestheticImage: "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/6f30c1ab1263a4b2a2735adca31c217584d9a9e12113dccbb65e4d19e1128aca.jpeg",
    notesImage: "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/b8951cac3010cd7a5e448ebb8a7c73e204e6444f9b78ef2c3972322688be59c4.jpeg",
    notes: { top: "Amber Resin", heart: "Tobacco Leaf", base: "Vanilla Bourbon · Sweet Woods" },
    price50: 1990,
    price10: 499,
    shopifyUrl: `${SHOPIFY_STORE}/products/ember-rush`,
    buyUrl: `${SHOPIFY_STORE}/products/ember-rush`,
  },
  {
    slug: "crimson-spice",
    families: ["Spicy", "Leather", "Ambery"],
    name: "Crimson Spice",
    collection: "for-him",
    accord: "Cinnamon Bark · Cardamom · Leather",
    description: "Bruised spice and burnished leather. Loud in intention, precise in execution.",
    image: "https://cdn.shopify.com/s/files/1/0735/8273/9521/files/crimson-spice-1-light_7bca0d28-2f1b-4bfc-9e0c-ee1c32a0d357.png",
    aestheticImage: "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/8f51d63bff5223bffb348eceec344dc7f4312b123cc817dd25d4c41e977fa40c.jpeg",
    notesImage: "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/71788033ebfdf9a36694b09202bb59329b7a5959188d97126f653e43584e8893.jpeg",
    notes: { top: "Cinnamon Bark", heart: "Green Cardamom · Star Anise", base: "Leather · Glowing Amber" },
    price50: 1990,
    price10: 499,
    shopifyUrl: `${SHOPIFY_STORE}/products/crimson-spice`,
    buyUrl: `${SHOPIFY_STORE}/products/crimson-spice`,
  },
  {
    slug: "velvet-rouge",
    families: ["Floral", "Gourmand", "Musky"],
    name: "Velvet Rouge",
    collection: "for-her",
    accord: "Turkish Rose · Praline · Musk",
    description: "Rose pressed into velvet, sweetened with praline. Intimacy at skin distance.",
    image: "https://cdn.shopify.com/s/files/1/0735/8273/9521/files/velvet-rouge-1-light_700023a7-432a-4eb3-80de-5d8fd0e5e02f.png",
    aestheticImage: "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/a7c4c68f4e1f010b06ca5c842acfa650af86ecdd98d70cf2b77e48248489d44f.jpeg",
    notesImage: "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/787abc38152474a9a9e588f4e28b02be88f93122033e1df8b4b1b75f36d9d1c4.jpeg",
    notes: { top: "Turkish Rose", heart: "Praline", base: "White Musk · Tonka Bean" },
    price50: 1990,
    price10: 499,
    shopifyUrl: `${SHOPIFY_STORE}/products/velvet-rouge`,
    buyUrl: `${SHOPIFY_STORE}/products/velvet-rouge`,
  },
];

export const COLLECTIONS = {
  unisex: {
    title: "Unisex",
    tagline: "Beyond definition",
    description: "Compositions that refuse category — built on raw materials, worn on intention.",
    image: "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/e61d437c15bce3f8c5216f8fc1d2921115e0bd4c112a4aefe8d181572448b919.png",
  },
  "for-him": {
    title: "For Him",
    tagline: "Quiet authority",
    description: "Structured, smoked and resolute. Fragrances engineered for presence, not attention.",
    image: "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/883b534777ff591b75efeaeb85f02a25e300748620dfe0d2be0030620172ed73.png",
  },
  "for-her": {
    title: "For Her",
    tagline: "Sillage as signature",
    description: "Florals with a spine — rose, saffron and musk composed at parfum strength.",
    image: "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/35277043dd9556a6dfa68923587ca06c62bea963acb7ac2d2c7bf42c2ff2d996.png",
  },
};

export const HERO_IMAGE = "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/ae468549cae81f67f36284083606194ed9c2d9ce89e152c67c8b0ffa676fc26b.jpeg";
export const PACKAGING_IMAGE = "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/c55e58b9f61627cc755bb941a7fbce601ce2ce0f5dbb9700073922506c347bc2.png";
export const BRAND_STORY_IMAGE = "https://static.prod-images.emergentagent.com/jobs/b655ee01-17a9-4f7f-b979-8d6244e2a8c9/images/2809f4a684f028d97358eb645ca4f8cf033f47153e917a24560b2b7a446c1e96.png";

export const REVIEWS = [
  { name: "Aarav M.", city: "Mumbai", rating: 5, text: "Ember Rush lasts a full 12 hours on my skin. People stop me to ask what I'm wearing — nothing under ₹10,000 has ever done that." },
  { name: "Ishita R.", city: "Delhi", rating: 5, text: "Rouge Éclipse smells like a niche import. The maturation genuinely shows — it opens dark and settles into something addictive." },
  { name: "Kabir S.", city: "Bengaluru", rating: 5, text: "Imperial Ash is the most refined vetiver I've worn. The packaging alone feels like a ₹15k house." },
  { name: "Meera V.", city: "Hyderabad", rating: 5, text: "Velvet Rouge's sillage is unreal. Ordered the roll-on to travel with — now I own three full bottles." },
];
;
